module.exports = {
      id: "3355abd8721ae457b33ee1c19075d7dastate-very-good.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#3355abd8721ae457b33ee1c19075d7dastate-very-good.svg",
      toString: function () {
        return this.url;
      }
    }